import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';

const FontSettings = ({ fontSize, setFontSize, lineHeight, setLineHeight }) => (
    <div className="font-settings-toolbar d-flex align-items-center gap-3">
        <FormGroup className="mb-0 d-flex align-items-center">
            <Label for="font-size-input" className="mr-2 mb-0">Размер шрифта:</Label>
            <Input
                className="mr-1 standard-text"
                id="font-size-input"
                type="number"
                min={10}
                max={48}
                value={fontSize}
                onChange={e => setFontSize(Number(e.target.value))}
                style={{ width: 80, display: 'inline-block' }}
            />
            <span className="mr-4">px</span>
        </FormGroup>
        <FormGroup className="mb-0 d-flex align-items-center">
            <Label for="line-height-input" className="mr-2 mb-0">Междустрочный интервал:</Label>
            <Input
                className="standard-text"
                id="line-height-input"
                type="number"
                min={1}
                max={3}
                step={0.1}
                value={lineHeight}
                onChange={e => setLineHeight(Number(e.target.value))}
                style={{ width: 80, display: 'inline-block' }}
            />
        </FormGroup>
    </div>
);

export default FontSettings;
